var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mr-1 ml-1 mt-2"},[_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('h4',[_vm._v("Il form di richiesta si aprirà tra breve...")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }